module.exports = __webpack_public_path__ + "static/img/SC14.e0c41c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC14.jpg
// module id = +Z1D
// module chunks = 0